//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    register(command: RegisterUserCommand): Promise<AuthResultDto> {
        let url_ = this.baseUrl + "/api/Auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<AuthResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResultDto>(null as any);
    }

    login(command: LoginCommand): Promise<AuthResultDto> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResultDto>(null as any);
    }

    refresh(request: RefreshRequest): Promise<AuthResultDto> {
        let url_ = this.baseUrl + "/api/Auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: Response): Promise<AuthResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResultDto>(null as any);
    }

    logout(request: RefreshRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    me(): Promise<CurrentUserDto> {
        let url_ = this.baseUrl + "/api/Auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: Response): Promise<CurrentUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentUserDto>(null as any);
    }

    changePassword(command: ChangePasswordCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getNote(refTableName: string | null | undefined, refId: string | null | undefined): Promise<NoteDto> {
        let url_ = this.baseUrl + "/api/Notes?";
        if (refTableName !== undefined && refTableName !== null)
            url_ += "RefTableName=" + encodeURIComponent("" + refTableName) + "&";
        if (refId !== undefined && refId !== null)
            url_ += "RefId=" + encodeURIComponent("" + refId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNote(_response);
        });
    }

    protected processGetNote(response: Response): Promise<NoteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NoteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto>(null as any);
    }

    saveNote(command: SaveNoteCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveNote(_response);
        });
    }

    protected processSaveNote(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class TodosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTodosForDay(date: string): Promise<DayOverviewVm> {
        let url_ = this.baseUrl + "/api/Todos/day/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTodosForDay(_response);
        });
    }

    protected processGetTodosForDay(response: Response): Promise<DayOverviewVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DayOverviewVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DayOverviewVm>(null as any);
    }

    getUnfinishedTodos(before: string, limit: number | null | undefined): Promise<TodoBriefDto[]> {
        let url_ = this.baseUrl + "/api/Todos/unfinished?";
        if (before === undefined || before === null)
            throw new Error("The parameter 'before' must be defined and cannot be null.");
        else
            url_ += "Before=" + encodeURIComponent("" + before) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnfinishedTodos(_response);
        });
    }

    protected processGetUnfinishedTodos(response: Response): Promise<TodoBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TodoBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TodoBriefDto[]>(null as any);
    }

    getTodosByRef(refTable: string | null, refId: string | null): Promise<TodoBriefDto[]> {
        let url_ = this.baseUrl + "/api/Todos/by-ref?";
        if (refTable === undefined)
            throw new Error("The parameter 'refTable' must be defined.");
        else if(refTable !== null)
            url_ += "RefTable=" + encodeURIComponent("" + refTable) + "&";
        if (refId === undefined)
            throw new Error("The parameter 'refId' must be defined.");
        else if(refId !== null)
            url_ += "RefId=" + encodeURIComponent("" + refId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTodosByRef(_response);
        });
    }

    protected processGetTodosByRef(response: Response): Promise<TodoBriefDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TodoBriefDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TodoBriefDto[]>(null as any);
    }

    getTodoDetail(id: string): Promise<TodoDetailDto> {
        let url_ = this.baseUrl + "/api/Todos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTodoDetail(_response);
        });
    }

    protected processGetTodoDetail(response: Response): Promise<TodoDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodoDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TodoDetailDto>(null as any);
    }

    updateTodo(id: string, command: UpdateTodoCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTodo(_response);
        });
    }

    protected processUpdateTodo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTodo(id: string): Promise<TodoDetailDto> {
        let url_ = this.baseUrl + "/api/Todos/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTodo(_response);
        });
    }

    protected processDeleteTodo(response: Response): Promise<TodoDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodoDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TodoDetailDto>(null as any);
    }

    createTodo(command: CreateTodoCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/Todos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTodo(_response);
        });
    }

    protected processCreateTodo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    restoreTodo(snapshot: TodoDetailDto): Promise<string> {
        let url_ = this.baseUrl + "/api/Todos/restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(snapshot);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreTodo(_response);
        });
    }

    protected processRestoreTodo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    moveTodoToDay(id: string, request: MoveTodoRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/move";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveTodoToDay(_response);
        });
    }

    protected processMoveTodoToDay(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reorderTodos(command: ReorderTodosCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReorderTodos(_response);
        });
    }

    protected processReorderTodos(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addTask(id: string, command: AddTaskCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddTask(_response);
        });
    }

    protected processAddTask(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTask(id: string, index: number, command: UpdateTaskCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/{index}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTask(_response);
        });
    }

    protected processUpdateTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeTask(id: string, index: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/{index}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveTask(_response);
        });
    }

    protected processRemoveTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setTaskResult(id: string, index: number, request: SetTaskResultRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/{index}/result";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTaskResult(_response);
        });
    }

    protected processSetTaskResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setTaskComment(id: string, index: number, request: SetTaskCommentRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/{index}/comment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetTaskComment(_response);
        });
    }

    protected processSetTaskComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reorderTasks(id: string, request: ReorderTasksRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/reorder";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReorderTasks(_response);
        });
    }

    protected processReorderTasks(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    startTask(id: string, index: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/{index}/start";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartTask(_response);
        });
    }

    protected processStartTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    finishTask(id: string, index: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/{index}/finish";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinishTask(_response);
        });
    }

    protected processFinishTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restartTask(id: string, index: number, request: RestartTaskRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/Todos/{id}/tasks/{index}/restart";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (index === undefined || index === null)
            throw new Error("The parameter 'index' must be defined.");
        url_ = url_.replace("{index}", encodeURIComponent("" + index));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestartTask(_response);
        });
    }

    protected processRestartTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthResultDto implements IAuthResultDto {
    accessToken?: string;
    accessTokenExpiresAt?: string;
    refreshToken?: string;
    refreshTokenExpiresAt?: string;
    user?: CurrentUserDto;

    constructor(data?: IAuthResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenExpiresAt = _data["accessTokenExpiresAt"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpiresAt = _data["refreshTokenExpiresAt"];
            this.user = _data["user"] ? CurrentUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenExpiresAt"] = this.accessTokenExpiresAt;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpiresAt"] = this.refreshTokenExpiresAt;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuthResultDto {
    accessToken?: string;
    accessTokenExpiresAt?: string;
    refreshToken?: string;
    refreshTokenExpiresAt?: string;
    user?: CurrentUserDto;
}

export class CurrentUserDto implements ICurrentUserDto {
    id?: string;
    email?: string;
    displayName?: string;
    timeZoneId?: string;
    emailConfirmed?: boolean;

    constructor(data?: ICurrentUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.timeZoneId = _data["timeZoneId"];
            this.emailConfirmed = _data["emailConfirmed"];
        }
    }

    static fromJS(data: any): CurrentUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["timeZoneId"] = this.timeZoneId;
        data["emailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface ICurrentUserDto {
    id?: string;
    email?: string;
    displayName?: string;
    timeZoneId?: string;
    emailConfirmed?: boolean;
}

export class RegisterUserCommand implements IRegisterUserCommand {
    email?: string;
    password?: string;
    displayName?: string;
    timeZoneId?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IRegisterUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.displayName = _data["displayName"];
            this.timeZoneId = _data["timeZoneId"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): RegisterUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["displayName"] = this.displayName;
        data["timeZoneId"] = this.timeZoneId;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IRegisterUserCommand {
    email?: string;
    password?: string;
    displayName?: string;
    timeZoneId?: string | undefined;
    ipAddress?: string | undefined;
}

export class LoginCommand implements ILoginCommand {
    email?: string;
    password?: string;
    ipAddress?: string | undefined;

    constructor(data?: ILoginCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): LoginCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface ILoginCommand {
    email?: string;
    password?: string;
    ipAddress?: string | undefined;
}

export class RefreshRequest implements IRefreshRequest {
    refreshToken?: string;

    constructor(data?: IRefreshRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshRequest {
    refreshToken?: string;
}

export class ChangePasswordCommand implements IChangePasswordCommand {
    currentPassword?: string;
    newPassword?: string;

    constructor(data?: IChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordCommand {
    currentPassword?: string;
    newPassword?: string;
}

export class NoteDto implements INoteDto {
    id?: string | undefined;
    refTableName?: string | undefined;
    refId?: string | undefined;
    description?: NoteTabDto[];

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refTableName = _data["refTableName"];
            this.refId = _data["refId"];
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(NoteTabDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refTableName"] = this.refTableName;
        data["refId"] = this.refId;
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        return data;
    }
}

export interface INoteDto {
    id?: string | undefined;
    refTableName?: string | undefined;
    refId?: string | undefined;
    description?: NoteTabDto[];
}

export class NoteTabDto implements INoteTabDto {
    title?: string;
    content?: string;

    constructor(data?: INoteTabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): NoteTabDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        return data;
    }
}

export interface INoteTabDto {
    title?: string;
    content?: string;
}

export class SaveNoteCommand implements ISaveNoteCommand {
    refTableName?: string | undefined;
    refId?: string | undefined;
    description?: NoteTabDto[];

    constructor(data?: ISaveNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refTableName = _data["refTableName"];
            this.refId = _data["refId"];
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(NoteTabDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refTableName"] = this.refTableName;
        data["refId"] = this.refId;
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveNoteCommand {
    refTableName?: string | undefined;
    refId?: string | undefined;
    description?: NoteTabDto[];
}

export class DayOverviewVm implements IDayOverviewVm {
    date?: string;
    todos?: TodoBriefDto[];
    summary?: DaySummaryDto;

    constructor(data?: IDayOverviewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            if (Array.isArray(_data["todos"])) {
                this.todos = [] as any;
                for (let item of _data["todos"])
                    this.todos!.push(TodoBriefDto.fromJS(item));
            }
            this.summary = _data["summary"] ? DaySummaryDto.fromJS(_data["summary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DayOverviewVm {
        data = typeof data === 'object' ? data : {};
        let result = new DayOverviewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        if (Array.isArray(this.todos)) {
            data["todos"] = [];
            for (let item of this.todos)
                data["todos"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDayOverviewVm {
    date?: string;
    todos?: TodoBriefDto[];
    summary?: DaySummaryDto;
}

export class TodoBriefDto implements ITodoBriefDto {
    id?: string;
    title?: string;
    todoDate?: string;
    targetTime?: string | undefined;
    priority?: PriorityLevel;
    sortOrder?: number;
    refTable?: string | undefined;
    refId?: string | undefined;
    status?: TodoStatusDto;

    constructor(data?: ITodoBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.todoDate = _data["todoDate"];
            this.targetTime = _data["targetTime"];
            this.priority = _data["priority"];
            this.sortOrder = _data["sortOrder"];
            this.refTable = _data["refTable"];
            this.refId = _data["refId"];
            this.status = _data["status"] ? TodoStatusDto.fromJS(_data["status"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TodoBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["todoDate"] = this.todoDate;
        data["targetTime"] = this.targetTime;
        data["priority"] = this.priority;
        data["sortOrder"] = this.sortOrder;
        data["refTable"] = this.refTable;
        data["refId"] = this.refId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITodoBriefDto {
    id?: string;
    title?: string;
    todoDate?: string;
    targetTime?: string | undefined;
    priority?: PriorityLevel;
    sortOrder?: number;
    refTable?: string | undefined;
    refId?: string | undefined;
    status?: TodoStatusDto;
}

export enum PriorityLevel {
    None = "None",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export class TodoStatusDto implements ITodoStatusDto {
    total?: number;
    completed?: number;
    partial?: number;
    notCompleted?: number;
    overall?: TodoProgressKind;

    constructor(data?: ITodoStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.completed = _data["completed"];
            this.partial = _data["partial"];
            this.notCompleted = _data["notCompleted"];
            this.overall = _data["overall"];
        }
    }

    static fromJS(data: any): TodoStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["completed"] = this.completed;
        data["partial"] = this.partial;
        data["notCompleted"] = this.notCompleted;
        data["overall"] = this.overall;
        return data;
    }
}

export interface ITodoStatusDto {
    total?: number;
    completed?: number;
    partial?: number;
    notCompleted?: number;
    overall?: TodoProgressKind;
}

export enum TodoProgressKind {
    NotCompleted = "NotCompleted",
    Partial = "Partial",
    Completed = "Completed",
}

export class DaySummaryDto implements IDaySummaryDto {
    todoCount?: number;
    taskTotal?: number;
    taskCompleted?: number;
    taskPartial?: number;
    taskNotCompleted?: number;
    completionPercent?: number;

    constructor(data?: IDaySummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todoCount = _data["todoCount"];
            this.taskTotal = _data["taskTotal"];
            this.taskCompleted = _data["taskCompleted"];
            this.taskPartial = _data["taskPartial"];
            this.taskNotCompleted = _data["taskNotCompleted"];
            this.completionPercent = _data["completionPercent"];
        }
    }

    static fromJS(data: any): DaySummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DaySummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todoCount"] = this.todoCount;
        data["taskTotal"] = this.taskTotal;
        data["taskCompleted"] = this.taskCompleted;
        data["taskPartial"] = this.taskPartial;
        data["taskNotCompleted"] = this.taskNotCompleted;
        data["completionPercent"] = this.completionPercent;
        return data;
    }
}

export interface IDaySummaryDto {
    todoCount?: number;
    taskTotal?: number;
    taskCompleted?: number;
    taskPartial?: number;
    taskNotCompleted?: number;
    completionPercent?: number;
}

export class TodoDetailDto implements ITodoDetailDto {
    id?: string;
    title?: string;
    todoDate?: string;
    targetTime?: string | undefined;
    priority?: PriorityLevel;
    sortOrder?: number;
    refTable?: string | undefined;
    refId?: string | undefined;
    status?: TodoStatusDto;
    todoTask?: TodoTaskDto[];
    createdAt?: string;
    updatedAt?: string;

    constructor(data?: ITodoDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.todoDate = _data["todoDate"];
            this.targetTime = _data["targetTime"];
            this.priority = _data["priority"];
            this.sortOrder = _data["sortOrder"];
            this.refTable = _data["refTable"];
            this.refId = _data["refId"];
            this.status = _data["status"] ? TodoStatusDto.fromJS(_data["status"]) : <any>undefined;
            if (Array.isArray(_data["todoTask"])) {
                this.todoTask = [] as any;
                for (let item of _data["todoTask"])
                    this.todoTask!.push(TodoTaskDto.fromJS(item));
            }
            this.createdAt = _data["createdAt"];
            this.updatedAt = _data["updatedAt"];
        }
    }

    static fromJS(data: any): TodoDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["todoDate"] = this.todoDate;
        data["targetTime"] = this.targetTime;
        data["priority"] = this.priority;
        data["sortOrder"] = this.sortOrder;
        data["refTable"] = this.refTable;
        data["refId"] = this.refId;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (Array.isArray(this.todoTask)) {
            data["todoTask"] = [];
            for (let item of this.todoTask)
                data["todoTask"].push(item.toJSON());
        }
        data["createdAt"] = this.createdAt;
        data["updatedAt"] = this.updatedAt;
        return data;
    }
}

export interface ITodoDetailDto {
    id?: string;
    title?: string;
    todoDate?: string;
    targetTime?: string | undefined;
    priority?: PriorityLevel;
    sortOrder?: number;
    refTable?: string | undefined;
    refId?: string | undefined;
    status?: TodoStatusDto;
    todoTask?: TodoTaskDto[];
    createdAt?: string;
    updatedAt?: string;
}

export class TodoTaskDto implements ITodoTaskDto {
    index?: number;
    content?: string;
    status?: TodoTaskStage;
    result?: string | undefined;
    restartReasons?: string[];
    priority?: PriorityLevel;
    estimateTime?: number;
    comment?: string;

    constructor(data?: ITodoTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.content = _data["content"];
            this.status = _data["status"];
            this.result = _data["result"];
            if (Array.isArray(_data["restartReasons"])) {
                this.restartReasons = [] as any;
                for (let item of _data["restartReasons"])
                    this.restartReasons!.push(item);
            }
            this.priority = _data["priority"];
            this.estimateTime = _data["estimateTime"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): TodoTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["content"] = this.content;
        data["status"] = this.status;
        data["result"] = this.result;
        if (Array.isArray(this.restartReasons)) {
            data["restartReasons"] = [];
            for (let item of this.restartReasons)
                data["restartReasons"].push(item);
        }
        data["priority"] = this.priority;
        data["estimateTime"] = this.estimateTime;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ITodoTaskDto {
    index?: number;
    content?: string;
    status?: TodoTaskStage;
    result?: string | undefined;
    restartReasons?: string[];
    priority?: PriorityLevel;
    estimateTime?: number;
    comment?: string;
}

export enum TodoTaskStage {
    New = "New",
    InProcess = "InProcess",
    End = "End",
}

export class CreateTodoCommand implements ICreateTodoCommand {
    title?: string;
    todoDate?: string;
    priority?: PriorityLevel;
    targetTime?: TargetTimeInput | undefined;
    refTable?: string | undefined;
    refId?: string | undefined;

    constructor(data?: ICreateTodoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.todoDate = _data["todoDate"];
            this.priority = _data["priority"];
            this.targetTime = _data["targetTime"] ? TargetTimeInput.fromJS(_data["targetTime"]) : <any>undefined;
            this.refTable = _data["refTable"];
            this.refId = _data["refId"];
        }
    }

    static fromJS(data: any): CreateTodoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["todoDate"] = this.todoDate;
        data["priority"] = this.priority;
        data["targetTime"] = this.targetTime ? this.targetTime.toJSON() : <any>undefined;
        data["refTable"] = this.refTable;
        data["refId"] = this.refId;
        return data;
    }
}

export interface ICreateTodoCommand {
    title?: string;
    todoDate?: string;
    priority?: PriorityLevel;
    targetTime?: TargetTimeInput | undefined;
    refTable?: string | undefined;
    refId?: string | undefined;
}

export class TargetTimeInput implements ITargetTimeInput {
    mode?: TargetTimeMode;
    at?: string | undefined;
    timeOfDay?: string | undefined;
    durationMinutes?: number | undefined;

    constructor(data?: ITargetTimeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.at = _data["at"];
            this.timeOfDay = _data["timeOfDay"];
            this.durationMinutes = _data["durationMinutes"];
        }
    }

    static fromJS(data: any): TargetTimeInput {
        data = typeof data === 'object' ? data : {};
        let result = new TargetTimeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["at"] = this.at;
        data["timeOfDay"] = this.timeOfDay;
        data["durationMinutes"] = this.durationMinutes;
        return data;
    }
}

export interface ITargetTimeInput {
    mode?: TargetTimeMode;
    at?: string | undefined;
    timeOfDay?: string | undefined;
    durationMinutes?: number | undefined;
}

export enum TargetTimeMode {
    None = "None",
    ExactDateTime = "ExactDateTime",
    TimeOfDay = "TimeOfDay",
    Duration = "Duration",
}

export class UpdateTodoCommand implements IUpdateTodoCommand {
    id?: string;
    title?: string;
    priority?: PriorityLevel;
    targetTime?: TargetTimeInput | undefined;
    refTable?: string | undefined;
    refId?: string | undefined;

    constructor(data?: IUpdateTodoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.priority = _data["priority"];
            this.targetTime = _data["targetTime"] ? TargetTimeInput.fromJS(_data["targetTime"]) : <any>undefined;
            this.refTable = _data["refTable"];
            this.refId = _data["refId"];
        }
    }

    static fromJS(data: any): UpdateTodoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["priority"] = this.priority;
        data["targetTime"] = this.targetTime ? this.targetTime.toJSON() : <any>undefined;
        data["refTable"] = this.refTable;
        data["refId"] = this.refId;
        return data;
    }
}

export interface IUpdateTodoCommand {
    id?: string;
    title?: string;
    priority?: PriorityLevel;
    targetTime?: TargetTimeInput | undefined;
    refTable?: string | undefined;
    refId?: string | undefined;
}

export class MoveTodoRequest implements IMoveTodoRequest {
    todoDate?: string;

    constructor(data?: IMoveTodoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todoDate = _data["todoDate"];
        }
    }

    static fromJS(data: any): MoveTodoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTodoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todoDate"] = this.todoDate;
        return data;
    }
}

export interface IMoveTodoRequest {
    todoDate?: string;
}

export class ReorderTodosCommand implements IReorderTodosCommand {
    todoDate?: string;
    orderedIds?: string[];

    constructor(data?: IReorderTodosCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todoDate = _data["todoDate"];
            if (Array.isArray(_data["orderedIds"])) {
                this.orderedIds = [] as any;
                for (let item of _data["orderedIds"])
                    this.orderedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderTodosCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderTodosCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todoDate"] = this.todoDate;
        if (Array.isArray(this.orderedIds)) {
            data["orderedIds"] = [];
            for (let item of this.orderedIds)
                data["orderedIds"].push(item);
        }
        return data;
    }
}

export interface IReorderTodosCommand {
    todoDate?: string;
    orderedIds?: string[];
}

export class AddTaskCommand implements IAddTaskCommand {
    todoId?: string;
    content?: string;
    priority?: PriorityLevel;
    estimateTime?: number;
    comment?: string | undefined;

    constructor(data?: IAddTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todoId = _data["todoId"];
            this.content = _data["content"];
            this.priority = _data["priority"];
            this.estimateTime = _data["estimateTime"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AddTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todoId"] = this.todoId;
        data["content"] = this.content;
        data["priority"] = this.priority;
        data["estimateTime"] = this.estimateTime;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IAddTaskCommand {
    todoId?: string;
    content?: string;
    priority?: PriorityLevel;
    estimateTime?: number;
    comment?: string | undefined;
}

export class UpdateTaskCommand implements IUpdateTaskCommand {
    todoId?: string;
    index?: number;
    content?: string;
    priority?: PriorityLevel;
    estimateTime?: number;
    comment?: string | undefined;

    constructor(data?: IUpdateTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.todoId = _data["todoId"];
            this.index = _data["index"];
            this.content = _data["content"];
            this.priority = _data["priority"];
            this.estimateTime = _data["estimateTime"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["todoId"] = this.todoId;
        data["index"] = this.index;
        data["content"] = this.content;
        data["priority"] = this.priority;
        data["estimateTime"] = this.estimateTime;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateTaskCommand {
    todoId?: string;
    index?: number;
    content?: string;
    priority?: PriorityLevel;
    estimateTime?: number;
    comment?: string | undefined;
}

export class SetTaskResultRequest implements ISetTaskResultRequest {
    result?: string;

    constructor(data?: ISetTaskResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): SetTaskResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTaskResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        return data;
    }
}

export interface ISetTaskResultRequest {
    result?: string;
}

export class SetTaskCommentRequest implements ISetTaskCommentRequest {
    comment?: string | undefined;

    constructor(data?: ISetTaskCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SetTaskCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetTaskCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISetTaskCommentRequest {
    comment?: string | undefined;
}

export class ReorderTasksRequest implements IReorderTasksRequest {
    newOrder?: number[];

    constructor(data?: IReorderTasksRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["newOrder"])) {
                this.newOrder = [] as any;
                for (let item of _data["newOrder"])
                    this.newOrder!.push(item);
            }
        }
    }

    static fromJS(data: any): ReorderTasksRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderTasksRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.newOrder)) {
            data["newOrder"] = [];
            for (let item of this.newOrder)
                data["newOrder"].push(item);
        }
        return data;
    }
}

export interface IReorderTasksRequest {
    newOrder?: number[];
}

export class RestartTaskRequest implements IRestartTaskRequest {
    reason?: string;

    constructor(data?: IRestartTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RestartTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RestartTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRestartTaskRequest {
    reason?: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}